define([
	"dojo/_base/declare",
	"csi/table/NewFrom",
	"csi/xml"
], function(declare,NewFrom,xml) {

	return declare(NewFrom, {
		_onAction: function() {
			// summary: create RoutingItem or SubRoutingItem to wrap copied SubRouting, pointing to its current revision
			this.validateNode(this.m_urlNode, true);
			var	typeNode = this.widget.relRoot.getTargetClass().getType();
			var urlItem = this.m_urlNode;
			var urlItemRev = xml.getUrlPath(urlItem, "Child:CurrentRevision");

			this.m_urlNode = this.createNewUrl();

			this.m_cnNew = this.m_writer.createNode(this.m_urlNode, typeNode)
				.changeAttribute("Actual", xml.ATTR_REF, urlItemRev)
				.changeAttribute("Original", xml.ATTR_REF, urlItemRev);
		},

		/**
		 * @override
		 * hide Save & Go in this case
		 */
		_canNavigate: function() {
			return false;
		}
	});
});